module.exports = __webpack_public_path__ + "img/urc-logo-colour.397e33d5.png";